import { createApp } from 'vue'
import { Icon, Swipe,  SwipeItem, Loading, Toast, Dialog, Popover } from 'vant'
import App from './App.vue'
import router from './router'
import i18n from './utils/languages/i18n_config'
import 'vant/lib/index.css'
import "/public/fonts/HarmonyOS_Regular/font.css";
import "/public/fonts/HarmonyOS_Bold/font.css";
import mountAnimation from './utils/mount_animation'
import Lenis from '@studio-freight/lenis'

const lenis = new Lenis()

function raf(time:any) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

const app = createApp(App)
mountAnimation(app)

app.use(Swipe).use(SwipeItem).use(Toast).use(router).use(Loading).use(Icon).use(Dialog).use(Popover).use(i18n).mount('#app')
